module.exports = __webpack_public_path__ + "8a59ccea6d58bf5aa4936e6b01263423.png";